import { remove } from 'lodash-es';
import { ApiNotificationItem, ApiSetCgm90EnrollmentRequest, CloseMethod } from 'src/app/core/models';

const notifications: ApiNotificationItem[] = [
  // {
  //   id: 11958,
  //   priority: 11,
  //   closeMethod: CloseMethod.Display,
  //   externalText: 'Display: externalText only',
  //   externalButtonLabel1: undefined,
  //   externalButtonLabel2: undefined,
  //   externalCustomActionId: undefined,
  // },
  {
    id: 11961,
    priority: 14,
    closeMethod: CloseMethod.Action,
    externalText: undefined,
    externalButtonLabel1: undefined,
    externalButtonLabel2: undefined,
    externalCustomActionId: 'CGM90ENROLL',
  },
  {
    id: 11959,
    priority: 12,
    closeMethod: CloseMethod.Action,
    externalText: 'Action: The externalText and externalButtonLabel1 are set and the externalCustomActionId is NOT set',
    externalButtonLabel1: 'External Button 1',
    externalButtonLabel2: undefined,
    externalCustomActionId: undefined,
  },
  {
    id: 11960,
    priority: 13,
    closeMethod: CloseMethod.Action,
    externalText: 'Action: externalText, button1, button2 set',
    externalButtonLabel1: 'button1',
    externalButtonLabel2: 'button2',
    externalCustomActionId: undefined,
  },
  // {
  //   id: 11961,
  //   priority: 14,
  //   closeMethod: CloseMethod.Expiration,
  //   externalText: 'Expiration: externalText only',
  //   externalButtonLabel1: undefined,
  //   externalButtonLabel2: undefined,
  //   externalCustomActionId: undefined,
  // },
];

export const getNotifications = (): ApiNotificationItem[] => [notifications[0]];

export const respondToNotification = (urlParams: any) => {
  const notificationId = parseInt(urlParams.notificationId);
  remove(notifications, (n) => n.id === notificationId);
};

export const setCgm90Enrollment = (urlParams: any, body: ApiSetCgm90EnrollmentRequest) => {
  const notificationId = body.notificationId;
  remove(notifications, (n) => n.id === notificationId);
};

// Error cases
/*
export const getNotifications = (): ApiNotificationItem[] => [
  // ID missing error
  {
    id: undefined,
    priority: 10,
    closeMethod: CloseMethod.Expiration,
    externalText: 'Missing ID error',
    externalButtonLabel1: 'Ok',
    externalButtonLabel2: 'Cancel',
    externalCustomActionId: 'CGM90_ENROLLMENT_FORM',
  },
  // Display or Expiration: Display and Expiration must have externalText
  {
    id: 1,
    priority: 11,
    closeMethod: CloseMethod.Display,
    externalText: undefined,
    externalButtonLabel1: undefined,
    externalButtonLabel2: undefined,
    externalCustomActionId: undefined,
  },
  // Display or Expiration must not have externalButtonLabel1, externalButtonLabel2, externalCustomActionId
  {
    id: 2,
    priority: 12,
    closeMethod: CloseMethod.Display,
    externalText: 'Should not have external buttons',
    externalButtonLabel1: 'Ok',
    externalButtonLabel2: 'Cancel',
    externalCustomActionId: 'CGM90_ENROLLMENT_FORM',
  },
  // Action: 'When customActionId is not set externalText and button1 should be set'
  {
    id: 3,
    priority: 13,
    closeMethod: CloseMethod.Action,
    externalText: undefined,
    externalButtonLabel1: undefined,
    externalButtonLabel2: 'Cancel',
    externalCustomActionId: undefined,
  },
  // Action: When customActionId is set; externalText, externalButtonLabel1, externalButtonLabel2 should not be set,
  {
    id: 4,
    priority: 14,
    closeMethod: CloseMethod.Action,
    externalText: 'text, button1, button2 set (should error)',
    externalButtonLabel1: 'button1',
    externalButtonLabel2: 'button2',
    externalCustomActionId: 'CGM90_ENROLLMENT_FORM',
  },
];
*/
